import { Dictionary } from '../../../Components/Common/CommonModel';

export const farmStateMapping: Dictionary<{
  label: string;
  color:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
}> = {
  1: { label: 'Inactive', color: 'default' },
  2: { label: 'Production', color: 'success' },
  3: { label: 'Staging', color: 'warning' },
  4: { label: 'Staging - Passed Autotests', color: 'info' },
  5: { label: 'Provisioning', color: 'primary' },
  6: { label: 'Maintenance', color: 'secondary' },
  7: { label: 'New', color: 'info' },
  8: { label: 'Test environment', color: 'info' },
  9: { label: 'Delete', color: 'default' },
};
